import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Title } from "capitalrx-components-2.0/lib/typography";

import { BlankPageWrapper } from "@/App/components/BlankPageWrapper";
import { MemberEligibilityContext } from "@/App/context/MemberEligibilityContext";

export const RecentActivityDashboardPage: FC = () => {
  const { t: translate } = useTranslation();
  const { memberEligibility } = useContext(MemberEligibilityContext);

  return (
    <BlankPageWrapper>
      <Stack spacing="large">
        {/* Welcome Header - following DashboardPage.tsx pattern */}
        <Title testId="welcome-header">
          {translate("DASHBOARD.recentActivityDashboard.welcomeHeader")}
          {memberEligibility.member.first_name || ""}
        </Title>
      </Stack>
    </BlankPageWrapper>
  );
};
